/**
 * The author opening a passage he has been holding.
 *
 * The one gesture that kind of encryption exists for, and it only goes one way: the
 * text leaves for good the moment it is confirmed. The dialog says so rather than
 * softening it, because there is no undo to fall back on.
 */

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'

interface ReleasePassageDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ReleasePassageDialog: React.FC<ReleasePassageDialogProps> = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth dir="rtl">
    <DialogTitle sx={{ textAlign: 'right' }}>לפתוח את הקטע לכולם?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        מרגע שהקטע נפתח, כל מי שקורא את הספר רואה אותו. אי אפשר לסגור בחזרה — מה שיצא, יצא.
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ flexDirection: 'row-reverse', justifyContent: 'flex-start', gap: 1, px: 3, pb: 2 }}>
      <Button onClick={onClose}>ביטול</Button>
      <Button variant="contained" onClick={onConfirm}>
        לפתוח
      </Button>
    </DialogActions>
  </Dialog>
)

export default ReleasePassageDialog
